<template>
    <div class="w-100">
        <div class="d-flex flex-row gap-2">
            <select class="form-control"
                    :class="{'form-control-solid': solid}"
                    v-model="preset">
                <option :value="getPresetDefault()" selected disabled>
                    {{ __('actions.please_select') }}
                </option>
                <option v-for="preset in (overwritePresets || presets)"
                        :key="preset.name"
                        :value="preset"
                >
                    {{ preset.name }} ({{ dimensionString(preset.dimensions) }})
                </option>
                <option v-if="allowCustom" disabled>
                    -------------------------------
                </option>
                <option v-if="allowCustom" :value="getPresetDefault('__custom')">
                    {{ __('form.custom_input') }}
                </option>
            </select>
            <button v-if="allowDeletion"
                    class="btn btn-light-danger"
                    @click="$emit('delete')"
            >
                <i class="fas fa-trash ml-1"/>
            </button>
        </div>

        <div v-if="preset.name === '__custom'" class="mt-3">
            <PackageDimensionsForm v-model="preset.dimensions"/>
        </div>
    </div>
</template>

<script>
import PackageDimensionsForm from "@components/Packages/PackageDimensionsForm.vue";
import {Ajax} from "@js/api/ajax";

export default {
    components: {PackageDimensionsForm},

    props: {
        storeUuid: String,
        allowCustom: Boolean,
        allowDeletion: Boolean,
        solid: Boolean,
        value: {
            type: Object,
            default() {
                return this.getPresetDefault()
            }
        },
        shippingIntegration: String,
        overwritePresets: Object
    },

    data() {
        return {
            presets: {},
            preset: this.value
        }
    },

    beforeMount() {
        if (this.overwritePresets === undefined) {
            Ajax.Packages.getPresets(this.storeUuid, this.shippingIntegration)
                .then(response => this.presets = response.data);
        }
    },

    methods: {
        dimensionString(dimensions) {
            return [
                this.unitWithValueString(dimensions.length, __('general.dimensions.l')),
                this.unitWithValueString(dimensions.width, __('general.dimensions.w')),
                this.unitWithValueString(dimensions.height, __('general.dimensions.h'))
            ].join(' x ');
        },

        unitWithValueString(unitWithValue, dimensionAbbreviation) {
            return `${dimensionAbbreviation} ${unitWithValue.value}${unitWithValue.unit}`;
        },

        getPresetDefault(name = '') {
            return {
                id: null,
                name: name,
                dimensions: {
                    width: {
                        value: 0.0,
                        unit: 'cm'
                    },
                    height: {
                        value: 0.0,
                        unit: 'cm'
                    },
                    length: {
                        value: 0.0,
                        unit: 'cm'
                    },
                }
            }
        }
    },

    watch: {
        preset: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit('input', newValue)
            }
        },
    }
}
</script>
